import { Directive, ElementRef, effect, inject, input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

/**
 * Native port of the v1 `ftLaunchPreviewUnavailable` directive (account-v1/src/
 * sections/platform/layer/launchPreviewUnavailable.directive.js): while the
 * expression is truthy the launch-preview anchor swaps its trailing icon for the
 * translated 'flipto.account.Unavailable' text ("Live Preview unavailable"), and
 * swaps back when it turns falsy. v1 rewrote elem.html() — here the icon element
 * is detached and a dedicated Text node appended instead, because innerHTML
 * rewrites would orphan Angular's interpolation text nodes. Rides alongside
 * [ftDisabled] (v1 always paired them).
 */
@Directive({ selector: '[ftLaunchPreviewUnavailable]' })
export class FtLaunchPreviewUnavailableDirective {
  readonly ftLaunchPreviewUnavailable = input.required<boolean>();

  private readonly el: HTMLElement = inject(ElementRef).nativeElement;
  private readonly translate = inject(TranslateService);
  private icon: Element | null = null;
  private unavailableText: Text | null = null;

  constructor() {
    effect(() => {
      const unavailable = this.ftLaunchPreviewUnavailable();
      if (unavailable && !this.unavailableText) {
        this.icon = this.el.querySelector('i');
        this.icon?.remove();
        this.unavailableText = document.createTextNode(this.translate.instant('flipto.account.Unavailable'));
        this.el.appendChild(this.unavailableText);
      } else if (!unavailable && this.unavailableText) {
        this.unavailableText.remove();
        this.unavailableText = null;
        if (this.icon) {
          this.el.appendChild(this.icon);
          this.icon = null;
        }
      }
    });
  }
}
